import React from "react";
import { Controller } from "react-hook-form";

import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

import Input from "../../../../../components/inputs/Input";

const UserDataComponent = ({ control, errors }) => {
  return (
    <section className="w-full">
      <div className="mb-7 w-full">
        <div className="rounded-2xl border-2 border-gray bg-white p-4 shadow-sm">
          <h2 className="mb-3 text-lg font-semibold">Datos del cliente </h2>
          <div className="grid gap-5 md:grid-cols-2">
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  classNameContainer="w-full mb-7"
                  classNameInput="w-full"
                  placeholder="Nombre y apellidos"
                  error={errors?.name?.message}
                  onChange={(e) => {
                    const value = e.target.value.replaceAll(
                      /[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g,
                      "",
                    );
                    field.onChange(value);
                  }}
                  required
                />
              )}
            />
            <Controller
              name="typeDocument"
              control={control}
              render={({ field }) => (
                <FormControl component="fieldset">
                  <p className="my-0 py-0 text-base">
                    Tipo de documento{" "}
                    <span className="text-center text-3xl text-critical">
                      *
                    </span>
                    {errors?.typeDocument && (
                      <span className="my-0 py-0 text-base text-critical">
                        {errors?.typeDocument?.message}
                      </span>
                    )}
                  </p>
                  <RadioGroup
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    <div className="flex flex-col md:flex-row md:justify-between">
                      <FormControlLabel
                        value={"CEDULA_CIUDADANIA"}
                        control={<Radio />}
                        label={"Cédula de ciudadanía"}
                      />
                      <FormControlLabel
                        value={"CEDULA_EXTRANJERIA"}
                        control={<Radio />}
                        label={"Cédula de extranjería"}
                      />
                    </div>
                  </RadioGroup>
                </FormControl>
              )}
            />
            <Controller
              name="numberDocument"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  classNameContainer="w-full mb-7"
                  classNameInput="w-full"
                  placeholder="Número de documento"
                  error={errors?.numberDocument?.message}
                  onChange={(e) => {
                    const value = e.target.value.replaceAll(/\D/g, "");
                    field.onChange(value);
                  }}
                  required
                />
              )}
            />
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  classNameContainer="w-full mb-7"
                  classNameInput="w-full"
                  placeholder="Correo electrónico"
                  error={errors?.email?.message}
                  required
                />
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserDataComponent;
